<template>
  <div>
    <div id="details" class="basic-1">
      <div class="container">
        <div class="row px-3 ">
          <div class="col-7 col-md-5 col-lg-6 col-xl-7">
            <div class="image-container mb-4">
              <img
                class="img-fluid"
                src="/images/details-1.svg"
                alt="طراحی سایت"
              />
            </div>
            <!-- end of image-container -->
          </div>
          <!-- end of col -->
          <div class="col-md-7 col-lg-6 col-xl-5">
            <div class="text-container ps-md-3">
                <div class="d-flex align-items-start mb-3">
                <i class="fas fa-check mx-2 my-1 text-danger"></i>
                  <div class="flex-1">
                    <h5>مشاوره رایگان</h5>
                    <small class="text-muted mb-4">مشاوره آنلاین، تلفنی و حضوری</small>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-3">
                <i class="fas fa-check m-1 text-danger"></i>
                  <div class="flex-1">
                    <h5>طراحی نقشه سایت</h5>
                    <small class="text-muted mb-4">
                      تعیین تعداد و عنوان صفحات
                      </small>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-3">
                <i class="fas fa-check m-1 text-danger"></i>
                  <div class="flex-1">
                    <h5>امکانات و ویژگی ها</h5>
                    <small class="text-muted mb-4">
                      بررسی تمامی ویژگی ها، بعلاه گرافیک، ترکیب رنگ ...
                      </small>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-3">
                <i class="fas fa-check m-1 text-danger"></i>
                  <div class="flex-1">
                    <h5>قرارداد</h5>
                    <small class="text-muted mb-4">
                      عقد قرارداد به صورت غیر حضوری و یا حضوری با هماهنگی قبلی
                      </small>
                  </div>
                </div>
                <div class="d-flex align-items-start mb-3">
                <i class="fas fa-check m-1 text-danger"></i>
                  <div class="flex-1">
                    <h5>پشتیبانی</h5>
                    <small class="text-muted mb-4">
                  یک سال پشتیبانی رایگان هدیه تیم مشاوران وب
                    </small>
                  </div>
                </div>
              <!-- <h2><span>Perfect solution</span><br> for your small business</h2> -->
              <!-- <p>Maecenas fringilla quam posuere, pellentesque est nec, gravida turpis. Integer vitae mollis felis. Integer id quam id tellus hendrerit laciniad binfer</p>
                        <p>Sed id dui rutrum, dictum urna eu, accumsan turpis. Fusce id auctor velit, sed viverra dui rem dina</p>
                        <a class="btn-solid-reg" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Modal</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>